import * as React from 'react';
import { ImpureIconContainer } from './utils/IconContainer';
var AlertCircleFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlertCircleFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z",
    fill: "gold"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlertCircleFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlertCircleFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 2,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.602a.379.379 0 0 1-.378-.345l-.38-4.28a.764.764 0 1 1 1.523.002l-.389 4.278A.379.379 0 0 1 8 9.602Zm.004 2.486a.925.925 0 0 1-.583-.187c-.161-.125-.242-.341-.242-.649 0-.315.08-.532.242-.649a.964.964 0 0 1 .583-.176c.22 0 .41.059.572.176.169.117.253.334.253.649s-.084.535-.253.66a.946.946 0 0 1-.572.176Z",
    fill: "#B36200"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlertCircleFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B36200",
    d: "M0 0h16v16H0z"
  }))));
});
export default AlertCircleFillYes;